var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersummaryAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6814 0.826904C6.02777 0.826904 4.66992 2.17249 4.66992 3.82091C4.66992 5.46933 6.02772 6.81492 7.6814 6.81492C9.34456 6.81492 10.7047 5.46933 10.7047 3.82091C10.7047 2.17249 9.34456 0.826904 7.6814 0.826904Z",
    fill: "#C3C6CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68346 9.83545C9.12016 9.83545 10.5565 10.0458 11.7447 10.4593V10.4591H11.7451C12.6737 10.7815 13.4468 11.2245 13.9652 11.7483C14.4835 12.2721 14.7584 12.8529 14.7584 13.5732V14.723H0.616699V13.5732C0.616699 12.7477 0.974762 12.0973 1.64456 11.5258C2.31435 10.9542 3.30286 10.5002 4.44705 10.2117C5.44817 9.95933 6.56576 9.83448 7.6832 9.83545L7.68346 9.83545Z",
    fill: "#C3C6CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9635 9.84149C17.0631 9.85448 18.1563 9.98941 19.1325 10.2465C20.2482 10.5404 21.2071 10.9932 21.8557 11.558C22.5044 12.1229 22.8506 12.763 22.8506 13.573V14.7228H15.8698V13.573C15.8698 12.5517 15.4373 11.6555 14.7551 10.9661C14.3955 10.6026 13.9688 10.2907 13.4937 10.0236C14.2883 9.89331 15.1269 9.83147 15.9633 9.84136L15.9635 9.84149Z",
    fill: "#C3C6CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7859 0.826904C14.1323 0.826904 12.7747 2.17249 12.7747 3.82091C12.7747 5.46933 14.1321 6.81492 15.7859 6.81492C17.4396 6.81492 18.7972 5.46933 18.7972 3.82091C18.7972 2.17249 17.4398 0.826904 15.7859 0.826904Z",
    fill: "#C3C6CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersummaryAccount);
export default __webpack_public_path__ + "static/media/ordersummary_account.64a4499a2dece445b5d18165b7da8a2f.svg";
export { ForwardRef as ReactComponent };